import { USER_STORAGE_ROOT } from './userStoragePaths';

const QUOTA_PATH_MARKERS = ['/quiz/', '/AssignmentSubmissions/'] as const;

/** 100MB 한도 집계·검사 대상 Storage 경로인지 여부 (퀴즈 문제 이미지, 과제 제출 이미지) */
export function isQuotaScopedStoragePath(path: string): boolean {
  const name = path.replace(/^\/+/, '');
  if (!name.startsWith(`${USER_STORAGE_ROOT}/`)) return false;
  return QUOTA_PATH_MARKERS.some((marker) => name.includes(marker));
}
